/* Zur Kiepe – SIGNATURE interactions */
(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Button ripple ---- */
  document.addEventListener('click', function(e){
    var b = e.target.closest('.btn');
    if(!b) return;
    var r = document.createElement('span'); r.className='rip';
    var rect = b.getBoundingClientRect();
    r.style.left = (e.clientX-rect.left)+'px';
    r.style.top  = (e.clientY-rect.top)+'px';
    r.style.width = r.style.height = Math.max(rect.width,rect.height)+'px';
    b.appendChild(r); setTimeout(function(){ r.remove(); }, 620);
  });

  /* ---- Bubbles in hero ---- */
  var bubbleBox = document.querySelector('.hero__bubbles');
  if(bubbleBox && !reduce){
    for(var i=0;i<22;i++){
      var s = 4 + Math.random()*14;
      var b = document.createElement('i');
      b.style.left = Math.random()*100+'%';
      b.style.width = b.style.height = s+'px';
      b.style.animationDuration = (6+Math.random()*9)+'s';
      b.style.animationDelay = (Math.random()*8)+'s';
      bubbleBox.appendChild(b);
    }
  }

  /* ---- Interactive water ripple canvas ---- */
  var canvas = document.querySelector('.hero__ripple');
  if(canvas && canvas.getContext && !reduce){
    var ctx = canvas.getContext('2d'), rings=[], hero=canvas.parentElement, last=0;
    function size(){ canvas.width = hero.offsetWidth; canvas.height = hero.offsetHeight; }
    size(); window.addEventListener('resize', size);
    function add(x,y){ rings.push({x:x,y:y,r:2,a:.5}); if(rings.length>40) rings.shift(); }
    hero.addEventListener('pointermove', function(e){
      var now=Date.now(); if(now-last<45) return; last=now;
      var rect=hero.getBoundingClientRect(); add(e.clientX-rect.left, e.clientY-rect.top);
    });
    hero.addEventListener('pointerdown', function(e){
      var rect=hero.getBoundingClientRect(); add(e.clientX-rect.left, e.clientY-rect.top); add(e.clientX-rect.left, e.clientY-rect.top);
    });
    (function loop(){
      ctx.clearRect(0,0,canvas.width,canvas.height);
      for(var i=rings.length-1;i>=0;i--){
        var r=rings[i]; r.r+=1.7; r.a-=.008;
        if(r.a<=0){ rings.splice(i,1); continue; }
        ctx.beginPath(); ctx.arc(r.x,r.y,r.r,0,Math.PI*2);
        ctx.strokeStyle='rgba(255,255,255,'+r.a+')'; ctx.lineWidth=1.5; ctx.stroke();
      }
      requestAnimationFrame(loop);
    })();
  }

  /* ---- Count-up ---- */
  function animateCount(el){
    var target = parseFloat(el.getAttribute('data-count')||'0');
    var suffix = el.getAttribute('data-suffix')||'';
    var dur=1400, t0=null;
    function tick(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/dur,1);
      var val = Math.floor(target*(1-Math.pow(1-p,3)));
      el.textContent = val.toLocaleString('de-DE')+suffix;
      if(p<1) requestAnimationFrame(tick); else el.textContent = target.toLocaleString('de-DE')+suffix;
    }
    requestAnimationFrame(tick);
  }
  if('IntersectionObserver' in window){
    var co = new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting){ animateCount(en.target); co.unobserve(en.target);} }); },{threshold:.6});
    document.querySelectorAll('[data-count]').forEach(function(el){ co.observe(el); });
  } else {
    document.querySelectorAll('[data-count]').forEach(function(el){ el.textContent = el.getAttribute('data-count'); });
  }

  /* ---- Card tilt ---- */
  if(!reduce && window.matchMedia('(hover:hover)').matches){
    document.querySelectorAll('[data-tilt]').forEach(function(card){
      card.addEventListener('pointermove', function(e){
        var r=card.getBoundingClientRect();
        var rx=((e.clientY-r.top)/r.height-.5)*-6, ry=((e.clientX-r.left)/r.width-.5)*6;
        card.style.transform='perspective(700px) rotateX('+rx+'deg) rotateY('+ry+'deg) translateY(-4px)';
      });
      card.addEventListener('pointerleave', function(){ card.style.transform=''; });
    });
  }

  /* ---- KI-Angelberater ---- */
  var ki = document.querySelector('[data-ki]');
  if(ki){
    var searchBase = ki.getAttribute('data-search') || '/search';
    var input = ki.querySelector('[data-ki-input]');
    var chips = ki.querySelectorAll('.ki__chip');
    var result = ki.querySelector('[data-ki-result]');
    var setup = ki.querySelector('[data-ki-setup]');
    var fishLabel = ki.querySelector('[data-ki-fish]');
    var link = ki.querySelector('[data-ki-link]');
    var DATA = {
      hecht:   { label:'Hecht', items:[
        ['Rute','Spinnrute 2,40–2,70 m','Wurfgewicht 40–80 g'],
        ['Rolle','Stationärrolle 4000er','stabile Bremse'],
        ['Schnur','Geflecht 0,15–0,18 mm','weit & direkt'],
        ['Köder','Gummifisch 12–15 cm / Wobbler','Hecht-Dekor'],
        ['Montage','Stahl- oder Titanvorfach','bissfest'],
        ['Extra','Großer Kescher & Hakenlöser','fischschonend'] ] },
      karpfen: { label:'Karpfen', items:[
        ['Rute','Karpfenrute 3,60 m','2,75–3,0 lbs'],
        ['Rolle','Freilaufrolle 6000er','großes Fassungsvermögen'],
        ['Schnur','Mono 0,30–0,35 mm','abriebfest'],
        ['Köder','Boilies & Pop-Ups','+ Partikel'],
        ['Montage','Haar-Rig / Method Feeder','Safety-Clip'],
        ['Futter','Grundfutter & Partikelmix','Lockwirkung'] ] },
      zander:  { label:'Zander', items:[
        ['Rute','Spinnrute 2,40 m','WG 10–35 g, sensibel'],
        ['Rolle','Stationärrolle 2500–3000er','feine Bremse'],
        ['Schnur','Geflecht 0,10–0,13 mm','max. Kontakt'],
        ['Köder','Gummifisch 8–12 cm','dezente Farben'],
        ['Montage','Jigkopf 7–18 g / Fluorocarbon','grundnah'],
        ['Extra','UV-Lampe & Zange','Nachtangeln'] ] },
      forelle: { label:'Forelle', items:[
        ['Rute','Forellenrute 1,80–2,10 m','WG 1–8 g'],
        ['Rolle','Stationärrolle 2000er','leicht & fein'],
        ['Schnur','Mono 0,18–0,22 mm','+ Fluorocarbon'],
        ['Köder','Teig, Spoons, Sbirolino','Forellensee'],
        ['Montage','Sbirolino- oder Grundmontage','feinfühlig'],
        ['Extra','Kleiner Kescher & Setzkescher',''] ] },
      wels:    { label:'Wels', items:[
        ['Rute','Wallerrute 2,80–3,00 m','WG bis 600 g'],
        ['Rolle','Big-Pit / Multirolle','extrem stark'],
        ['Schnur','Geflecht 0,50–0,70 mm','hohe Tragkraft'],
        ['Köder','Tauwurmbündel, Köderfisch, Pellets',''],
        ['Montage','U-Pose / Grundmontage','starke Haken'],
        ['Extra','Handschuhe & Wallerholz','Sicherheit'] ] },
      barsch:  { label:'Barsch', items:[
        ['Rute','Ultra-Light 1,90–2,20 m','WG 2–12 g'],
        ['Rolle','Stationärrolle 1000–2500er','leicht'],
        ['Schnur','Geflecht 0,06–0,10 mm','+ FC-Vorfach'],
        ['Köder','Mini-Gummis, Spinner, Drop-Shot',''],
        ['Montage','Drop-Shot / Jig 2–7 g','filigran'],
        ['Extra','Kleine Zange & Boxen',''] ] },
      aal:     { label:'Aal', items:[
        ['Rute','Grund-/Aalrute 2,70–3,30 m','WG 60–120 g'],
        ['Rolle','Stationärrolle 4000er mit Freilauf','robust'],
        ['Schnur','Mono 0,30–0,35 mm','abriebfest'],
        ['Köder','Tauwurm, Köderfischfetzen, Made',''],
        ['Montage','Grund-/Durchlaufmontage','Laufblei, kräftiger Haken'],
        ['Extra','Kopflampe & Aalglocke','Nachtangeln'] ] },
      schleie: { label:'Schleie', items:[
        ['Rute','Feeder-/Matchrute 3,60–3,90 m','leicht, WG bis 60 g'],
        ['Rolle','Stationärrolle 3000er','feine Bremse'],
        ['Schnur','Mono 0,20–0,25 mm','+ feines Vorfach'],
        ['Köder','Made, Dendrobena, Mais',''],
        ['Montage','Posen- oder Feedermontage','feiner Haken 10–14'],
        ['Futter','Süßes Grundfutter','morgens am Kraut'] ] },
      brasse:  { label:'Brasse', items:[
        ['Rute','Feederrute 3,60–3,90 m','mittleres WG'],
        ['Rolle','Stationärrolle 3000–4000er',''],
        ['Schnur','Mono 0,20–0,25 mm',''],
        ['Köder','Maden, Mais, Pellets',''],
        ['Montage','Feeder-/Method-Montage','feine Haken'],
        ['Futter','Grundfutter (Bream-Mix)','große Lockwolke'] ] },
      rotauge: { label:'Rotauge / Weißfisch', items:[
        ['Rute','Match-/Stipprute 3,00–4,00 m','sehr leicht'],
        ['Rolle','Stationärrolle 2000er','für Matchrute'],
        ['Schnur','Mono 0,14–0,18 mm','fein'],
        ['Köder','Maden, Caster, Brot, Mais',''],
        ['Montage','Feine Posenmontage','Haken 16–20'],
        ['Futter','Feines Grundfutter','sparsam füttern'] ] }
    };
    function render(key){
      var d = DATA[key]; if(!d) return;
      if(fishLabel) fishLabel.textContent = d.label;
      if(setup) setup.innerHTML = d.items.map(function(it){
        return '<div class="ki__item"><div class="k">'+it[0]+'</div><div class="v">'+it[1]+'</div><div class="n">'+(it[2]||'')+'</div></div>';
      }).join('');
      if(link){ link.setAttribute('href', searchBase+'?q='+encodeURIComponent(d.label)); link.textContent = 'Alles für '+d.label+' ansehen'; }
      if(result){ result.classList.add('active'); }
      chips.forEach(function(c){ c.classList.toggle('on', c.getAttribute('data-fish')===key); });
    }
    chips.forEach(function(c){ c.addEventListener('click', function(){ render(c.getAttribute('data-fish')); if(input) input.value=c.textContent.trim(); }); });
    if(input){ input.addEventListener('keydown', function(e){
      if(e.key==='Enter'){ e.preventDefault(); var v=(input.value||'').toLowerCase();
        var found=Object.keys(DATA).filter(function(k){ return v.indexOf(k)>-1 || v.indexOf(DATA[k].label.toLowerCase())>-1; })[0];
        if(found) render(found);
        else if(link){ link.setAttribute('href', searchBase+'?q='+encodeURIComponent(input.value)); window.location.href = link.getAttribute('href'); }
      }
    }); }
  }

  /* ---- Live-Shopping Countdown ---- */
  var cd = document.querySelector('[data-countdown]');
  if(cd){
    var target = new Date(cd.getAttribute('data-countdown')).getTime();
    var eD=cd.querySelector('[data-d]'), eH=cd.querySelector('[data-h]'), eM=cd.querySelector('[data-m]'), eS=cd.querySelector('[data-s]');
    function pad(n){ return (n<10?'0':'')+n; }
    function upd(){ if(isNaN(target)) return; var t=target-Date.now(); if(t<0)t=0;
      if(eD)eD.textContent=pad(Math.floor(t/86400000));
      if(eH)eH.textContent=pad(Math.floor(t/3600000)%24);
      if(eM)eM.textContent=pad(Math.floor(t/60000)%60);
      if(eS)eS.textContent=pad(Math.floor(t/1000)%60); }
    upd(); setInterval(upd,1000);
  }
})();
